import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Button, Header, Icon, Image, Modal } from 'semantic-ui-react';
import { useStore } from '../../../../app/stores/store';
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { userLanguage } from '../../../../app/common/userLanguageSchema/userLanguage';
import Movementiview from './Movementiview';

function MovementTracker() {
  const { activityStore, commonStore, userStore } = useStore();
  const [open, setOpen] = useState(false);
  const {
    selectedActivity: activity,
    loadMovementHistory,
    movementtracker,
  } = activityStore;

  useEffect(() => {
    loadMovementHistory(activity?.id);
    // eslint-disable-next-line
  }, [activity]);

  const changeDateTime = (data: string) => {
    return new Date(data).toLocaleString();
  };

  return (
    <div
      className="user-tracker-small"
      style={{
        position:
          userStore.user?.customerName === 'Museum' ? 'absolute' : 'relative',
        right: userStore.user?.customerName === 'Museum' ? '16px' : '0',
      }}
    >
      {}
      {activityStore.setOpenmovementview === true && <Movementiview />}
      <Modal
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={open}
        trigger={
          commonStore.filterModeTwo?.includes('AVLAVTB01') ? null : (
            <Button
              color="teal"
              disabled={commonStore.filterModeZero?.includes('AVLAVTB01')}
              style={{
                marginTop:
                  userStore.user?.customerName === 'Museum' ? 0 : '10px',
              }}
              //Movement Tracker
            >
              {
                (
                  userLanguage[0].AssetViewItemLevelAllAssetsView
                    .AVLAVB03 as any
                )?.[`${commonStore.language.key}`]
              }
            </Button>
          )
        }
      >
        <Modal.Header>
          <span className="movementTrackheader">
            <p>Movement Tracker</p>
            <Icon
              name="table"
              style={{
                fontSize: '30px',
                marginRight: '30px',
                marginTop: '10px',
              }}
              color="teal"
              onClick={() => {
                activityStore.setopenviewmodel(true);
                setOpen(false);
              }}
            />
          </span>
        </Modal.Header>
        <Modal.Content
          style={{
            height: '40vh',
            overflowY: 'scroll',
            backgroundColor: '#eee',
          }}
        >
          {movementtracker.length <= 0 ? (
            <Header
              as="h3"
              style={{
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
              }}
            >
              Sorry no data to show
            </Header>
          ) : (
            <VerticalTimeline>
              {movementtracker.length >= 1 &&
                movementtracker?.map((history: any) => (
                  <VerticalTimelineElement
                    key={history.id}
                    className="vertical-timeline-element-subtitle"
                    contentStyle={{
                      background: 'rgb(33, 150, 243)',
                      color: '#fff',
                    }}
                    contentArrowStyle={{
                      borderRight: '7px solid  rgb(33, 150, 243)',
                    }}
                    iconStyle={{
                      background: '#fff',
                      color: '#fff',
                    }}
                    icon={
                      <Image
                        style={{
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                        size="small"
                        avatar
                        src="https://cdn-icons-png.flaticon.com/512/6119/6119533.png"
                      />
                    }
                  >
                    <h3 className="vertical-timeline-element-title">
                      {history?.username}
                    </h3>
                    <h1 className="vertical-timeline-element-title">
                      {history?.month > 0 && history?.month + ' month'}{' '}
                      {history?.days > 0 && history?.days + ' days'}{' '}
                      {history?.hours > 0 && history?.hours + ' hr'}{' '}
                      {history?.mins > 0 && history?.mins + ' mins'}{' '}
                      {history?.sec > 0 && history?.sec + ' secs'}
                    </h1>
                    {/* {history?.status.includes('Asset present inside') ? (
                      <Image
                        src="https://icon-library.com/images/door-icon/door-icon-2.jpg"
                        style={{
                          position: 'absolute',
                          right: 35,
                          height: '60px',
                          width: '60px',
                          marginTop: '20px',
                          color: 'white',
                          filter: 'invert(100%)',
                        }}
                      />
                    ) : null} */}
                    <p>
                      {history?.directionFrom} -{' '}
                      {changeDateTime(history?.fromTime)}
                    </p>
                    <p>
                      {history?.directionTo} - {changeDateTime(history?.toTime)}
                    </p>
                    <p>{history?.status}</p>
                  </VerticalTimelineElement>
                ))}
            </VerticalTimeline>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button color="black" onClick={() => setOpen(false)}>
            Close
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
}

export default observer(MovementTracker);
